export const NO_IMAGE_URL = "/static/images/common/no-image.svg";
